!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.index = t() : e.index = t();
}(this, function () {
  return function () {
    "use strict";

    var e = {
      d: function d(t, n) {
        for (var r in n) {
          e.o(n, r) && !e.o(t, r) && Object.defineProperty(t, r, {
            enumerable: !0,
            get: n[r]
          });
        }
      },
      o: function o(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      },
      r: function r(e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(e, "__esModule", {
          value: !0
        });
      }
    },
        t = {};
    e.r(t), e.d(t, {
      CONFIG_TYPES: function CONFIG_TYPES() {
        return i;
      },
      configGateInterceptor: function configGateInterceptor() {
        return a;
      },
      configInterceptor: function configInterceptor() {
        return u;
      }
    });

    var _n = function n() {
      return _n = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) {
          for (var o in t = arguments[n]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }, _n.apply(this, arguments);
    },
        r = function r(e, t, n, _r) {
      return new (n || (n = Promise))(function (o, i) {
        function c(e) {
          try {
            a(_r.next(e));
          } catch (e) {
            i(e);
          }
        }

        function u(e) {
          try {
            a(_r.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function a(e) {
          var t;
          e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(c, u);
        }

        a((_r = _r.apply(e, t || [])).next());
      });
    },
        o = function o(e, t) {
      var n,
          r,
          o,
          i,
          c = {
        label: 0,
        sent: function sent() {
          if (1 & o[0]) throw o[1];
          return o[1];
        },
        trys: [],
        ops: []
      };
      return i = {
        next: u(0),
        throw: u(1),
        return: u(2)
      }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
        return this;
      }), i;

      function u(i) {
        return function (u) {
          return function (i) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; c;) {
              try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;

                  case 4:
                    return c.label++, {
                      value: i[1],
                      done: !1
                    };

                  case 5:
                    c.label++, r = i[1], i = [0];
                    continue;

                  case 7:
                    i = c.ops.pop(), c.trys.pop();
                    continue;

                  default:
                    if (!((o = (o = c.trys).length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                      c = 0;
                      continue;
                    }

                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      c.label = i[1];
                      break;
                    }

                    if (6 === i[0] && c.label < o[1]) {
                      c.label = o[1], o = i;
                      break;
                    }

                    if (o && c.label < o[2]) {
                      c.label = o[2], c.ops.push(i);
                      break;
                    }

                    o[2] && c.ops.pop(), c.trys.pop();
                    continue;
                }

                i = t.call(e, c);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
            }

            if (5 & i[0]) throw i[1];
            return {
              value: i[0] ? i[1] : void 0,
              done: !0
            };
          }([i, u]);
        };
      }
    },
        i = {
      AXIOS: "axios",
      FETCH: "fetch"
    },
        c = function c(e, t) {
      return _n(_n(_n({}, e), t), {
        headers: _n(_n({}, null == e ? void 0 : e.headers), null == t ? void 0 : t.headers)
      });
    },
        u = function u(e) {
      var t,
          n = e.config,
          u = void 0 === n ? {
        type: i.FETCH
      } : n,
          a = e.responseCallback,
          l = e.errorCallback,
          s = e.customOptions;
      return u.type === i.AXIOS ? ((t = u.instance).interceptors.request.use(function (e) {
        return c(e, s);
      }, function (e) {
        return l && l(e), Promise.reject(e);
      }), void t.interceptors.response.use(function (e) {
        return r(void 0, void 0, void 0, function () {
          return o(this, function (t) {
            switch (t.label) {
              case 0:
                return a ? [4, a(e, e.data)] : [3, 2];

              case 1:
                t.sent(), t.label = 2;

              case 2:
                return [2, e];
            }
          });
        });
      }, function (e) {
        return l && l(e), Promise.reject(e);
      })) : function () {
        if ("undefined" != typeof window) {
          var e = window.fetch;

          window.fetch = function (t, n) {
            var i = c(n, s);
            return e(t, i).then(function (e) {
              return r(void 0, void 0, void 0, function () {
                var t, n, r;
                return o(this, function (o) {
                  switch (o.label) {
                    case 0:
                      if (e.ok) return [3, 1];
                      throw (t = new Error(e.statusText)).data = e, l && l(t), t;

                    case 1:
                      return [4, null === (r = e.clone()) || void 0 === r ? void 0 : r.json()];

                    case 2:
                      return n = o.sent(), a ? [4, a(e, n)] : [3, 4];

                    case 3:
                      o.sent(), o.label = 4;

                    case 4:
                      return [2, e];
                  }
                });
              });
            }).catch(function (e) {
              throw l && l(e), e;
            });
          };
        }
      }();
    },
        a = function a(e) {
      var t = e.clientId,
          n = e.targetUrl,
          c = e.config,
          a = void 0 === c ? {
        type: i.FETCH
      } : c,
          l = e.responseCallback;
      u({
        config: a,
        customOptions: {
          headers: {
            "x-agent-id": t,
            targetUrl: n
          }
        },
        responseCallback: function responseCallback(e, t) {
          return r(void 0, void 0, void 0, function () {
            return o(this, function (n) {
              return l && l(e, t), [2];
            });
          });
        }
      });
    };

    return t;
  }();
});